import BasicResource from '@/api/resource';

class CategoriesResource extends BasicResource {
    constructor () {
        super('config/categories');
    }

    retrieve (id) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/categories/${id}/enable`,
        });
    }

    delete (id, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/categories/${id}/disable`,
            data,
        });
    }
}

export default new CategoriesResource;
